
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import notifications from "@/lib/notifications";
import { InventorySummaryListFilters } from "@/models/api/barcodeSystem/inventory/summary";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const inventoryModuleState = getModule(InventoryModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class InventorySummaryFilters extends Vue {
  localFilters: InventorySummaryListFilters = null;

  get filters() {
    return inventoryModuleState.summaryFilters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    inventoryModuleState.setSummaryFilters(JSON.parse(JSON.stringify(this.localFilters)));
    inventoryModuleState.setLoading(true);
    try {
      await inventoryModuleState.getInventorySummary({
        pageNumber: 1,
        pageSize: inventoryModuleState.summaryPageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Inventory Summary", "Failed to load inventory summary", ex);
    }

    inventoryModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
